import {
  agent,
  agentCallSummaryReport,
  agentMissedCallReport,
  agentMissedRate,
  agentPerfReport,
  AgentPerfReportResponse,
  avgWaitTime,
  callbackSummaryReport,
  perfFilter,
  perfReport,
  slaReport,
} from "../../containers/ccsmodule/Reports/components/reportTypes";
import { SupervisorReportsType } from "../action-types/supervisorReports.action.types";

export const setAvgReports = (data: avgWaitTime[]) => {
  return {
    type: SupervisorReportsType.SET_AVGWAIT,
    payload: data,
  };
};

export const setTimeInterval = (data: string) => {
  return {
    type: SupervisorReportsType.SET_TIME_INTERVAL,
    payload: data,
  };
};

export const setPerfReport = (data: perfReport[]) => {
  return {
    type: SupervisorReportsType.SET_PERFREPORT,
    payload: data,
  };
};

export const setPerfReportTable = (data: perfReport[]) => {
  return {
    type: SupervisorReportsType.SET_PERFREPORTTABLE,
    payload: data,
  };
};

export const setPerfFilters = (data: { type?: string; values?: string[] }) => {
  return {
    type: SupervisorReportsType.SET_FILTERS,
    payload: data,
  };
};
export const setReportLoader = (data: { value: string, action: "add" | "remove" }) => {
  return {
    type: SupervisorReportsType.SETREPORTLOADER,
    payload: data,
  };
};
export const setSlaReport = (data: slaReport[]) => {
  return {
    type: SupervisorReportsType.SET_SLAREPORT,
    payload: data,
  };

}

export const setCallbackSummaryReport = (data: callbackSummaryReport) => {
  return {
    type: SupervisorReportsType?.SET_CALLBACKSUMMARYREPORT,
    payload: data
  }
}


export const setCallbackFilters = (data: string[]) => {
  return {
    type: SupervisorReportsType?.SET_CALLBACKFILTERS,
    payload: data
  }
}



export const setAllAgents = (data: agent[]) => {
  return {
    type: SupervisorReportsType?.SET_ALLAGENTS,
    payload: data
  }
}


export const setAgentCallSummaryReport = (data: agentCallSummaryReport[]) => {
  return {
    type: SupervisorReportsType?.SET_AGENTCALLSUMMARYREPORT,
    payload: data
  }
}

export const setAgentCallSummaryTypes = (data: string[]) => {
  return {
    type: SupervisorReportsType?.SET_AGENTCALLSUMMARYTYPES,
    payload: data
  }
}
export const setAgentPerfReportTypes = (data: string[]) => {
  return {
    type: SupervisorReportsType?.SET_AGENTPERFREPORTTYPES,
    payload: data
  }
}


export const setAgentPerfReport = (data: AgentPerfReportResponse) => {
  return {
    type: SupervisorReportsType?.SET_AGENTPERFREPORT,
    payload: data
  }
}


export const setAgentMissedCallReport = (data: agentMissedCallReport) => {
  return {
    type: SupervisorReportsType?.SET_AGENTMISSEDCALLREPORT,
    payload: data
  }
}
export const setAgentMissedRate = (data: agentMissedRate) => {
  return {
    type: SupervisorReportsType?.SET_AGENTMISSEDRATE,
    payload: data
  }
}

export const setReportsState = (data: string) => {
  return {
    type: SupervisorReportsType?.SET_CLEARSTATE,
    payload: data
  }
}







// 